import styled from "styled-components/macro";

export const MakeAPaymentWrapper = styled.div`
  position: fixed;
  right: 90px;
  z-index: 12;
`;
